import React from "react";
import Layout from "../../components/Layout/Layout";
import * as S from "./Styles";

const NotFound = () => {
  return (
    <Layout
      title="404 - Siden finnes ikke | Grønvold Byggservice"
      description="Beklager, siden du prøvde å besøke finnes ikke. Gå tilbake til forsiden og finn det du leter etter.">
      <S.Wrapper>
        <S.StyledHeader>Oops!</S.StyledHeader>
        <S.StyledText>Siden du leter etter finnes ikke.</S.StyledText>
        <S.StyledLink to="/">Ta meg hjem!</S.StyledLink>
      </S.Wrapper>
    </Layout>
  );
};

export default NotFound;
